/**
 * Generated by orval from the Collective Payroll API contract. Do not edit manually.
 */

/**
 * * `employee` - employee
 * * `contractor` - contractor
 */
export type WorkerTypeEnum = (typeof WorkerTypeEnum)[keyof typeof WorkerTypeEnum];

export const WorkerTypeEnum = {
    employee: 'employee',
    contractor: 'contractor',
} as const;
